import { createFileRoute } from "@tanstack/react-router";

import NewPassword from "./-components/NewPassword";

export const Route = createFileRoute("/_app/resetpassword/newpassword")({
  component: NewPassword,
});
